import { CheckmarkFilled } from '@carbon/icons-react';
import { startCase } from 'lodash-es';
import classNames from 'classnames';

const getStatusStyles = (statusDescription) => {
  const status = statusDescription?.toLowerCase();
  if (status === 'reviewed') {
    return {
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-700',
      icon: CheckmarkFilled,
    };
  } else if (status === 'incomplete') {
    return {
      bg: 'bg-gray-200',
      border: 'border-gray-300',
      text: 'text-gray-700',
      icon: null,
    };
  } else if (status === 'submitted') {
    return {
      bg: 'bg-yellow-50',
      border: 'border-yellow-300',
      text: 'text-yellow-800',
      icon: null,
    };
  }

  return {
    bg: 'bg-gray-200',
    border: 'border-gray-300',
    text: 'text-gray-700',
    icon: null,
  };
};

const ApplicationStatusCard = ({ status, className }) => {
  const styles = getStatusStyles(status);
  const StatusIcon = styles.icon;

  return (
    <div className={classNames('rounded-lg p-4 border-solid border', styles.bg, styles.border, className)}>
      <div className={classNames('flex items-center gap-1.5', styles.text, 'text-lg font-medium')}>
        <span>{startCase(status?.toLowerCase() || 'N/A')}</span>
        {StatusIcon && <StatusIcon className="w-5 h-5" />}
      </div>
    </div>
  );
};

export default ApplicationStatusCard;
